skrilla.controller('combinedAccountDetailsCtrl', function ($scope, searchService, $stateParams, srefService, paginationService, queryService, modalService, envService) {
    $scope.pageKey = "accountDetails";
    $scope.entries = [];

    $scope.account = {purpose: $stateParams.id};

    $scope.reset = function () {
        $scope.query = {
            limit: 20,
            afterDate: "",
            beforeDate: "",
            getCombinedRunningBalance: false,
            skipCount: true
        };
    };
    $scope.reset();

    $scope.search = function () {
        paginationService.resetPage($scope.pageKey);
        paginationService.pageQuery(getEntries, $scope.pageKey);
    }

    function getEntries() {
        return searchService.get('accounts/system/' + $stateParams.id + '/' + $stateParams.currency + '/entries/' + queryService.getQueryString($scope.query, $scope.pageKey)).then(function(response) {
            $scope.entries = response.data.result;
            paginationService.setPage($scope.pageKey, paginationService.buildPage(response));
        });
    }


    $scope.getCurrency = function(){
        return $stateParams.currency;
    }


    function getCurrentBalance() {
        searchService.get('accounts/system/' + $stateParams.id + '/' + $stateParams.currency + '/balance', "Error getting accounts", true).then(function (response) {
            $scope.account.currentBalance = response.data;
            if(!$scope.types) {
                searchService.get('accounts/system/' + $stateParams.id + '/' + $stateParams.currency + '/entryTypes').then(function (response) {
                    $scope.types = response.data;
                });
            }
        });
    }

    getCurrentBalance();
});

